import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { LoginDisplay } from './types';
import { getLoginDisplay } from './services';
export const KEY = 'login-display';
export function useLoginDisplay(): UseQueryResult<LoginDisplay['Response'], Error> {
  return useQuery({
    queryKey: [KEY],
    queryFn: getLoginDisplay
  });
}